<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="addBtnClick">添加解析</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="sort"
		      label="权重"
		      align="center"
		      width="80"
        >
		    </el-table-column>
		    
		    <el-table-column
		      label="封面图片"
		      align="center"
        >
          <template slot-scope="scope">
             <img :src="imgDomain + scope.row.project_analysis_icon"  class="project-img">
          </template>
		    </el-table-column>
        <el-table-column
          prop="title"
          label="解析标题"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="project_background"
          label="项目背景"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="tag_name"
          label="标签"
          align="center"
        >
        </el-table-column> -->
        <el-table-column
          prop="create_time"
          label="添加时间"
          align="center"
          width="160"
        >
        </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="150"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editAnalysisClick(scope.row)">编辑</span>
         	    <span class="opration-item" @click="deleteAnalysisClick(scope.row)">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
		  <common-pagination
			  :total="total"
        :page_size="page_size"
			  @size-change="handelPagesizeChange"
			  @page-change="handlePageChange"
			></common-pagination>
    </div>
    <common-dialog
    :title="dialogTitle"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		  <div v-if="dialogType === 'delete'">
          是否删除该产品解析？
        </div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonDialog from '@/components/CommonDialog';
import CommonPagination from '@/components/CommonPagination';
import { getAnalysisList, deleteAnalysis } from '@/api/product-analysis';

export default {
  name: 'casemanage',
  data() {
  	return {
      tableData: [
        {
        	id: 1, 
        	sort: 1, 
        	cover_img: '1', 
        	title: '我是案例标题', 
        	background: '大客户案例', 
        	label: [
            {name: '餐饮', id: '1'},
            {name: 'o2o', id: '2'}
        	], 
        	create_time: '2019-06-05 14:22:15'
        }
      ],
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      handle_row: {},
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  	}
  },
  computed: {
  	...mapState(['imgDomain'])
  },
  mounted() {
    this._getAnalysisList();
  },
  components: {
     CommonDialog,
     CommonPagination
  },
  methods: {
    async _getAnalysisList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size
      };
      const { data, status } = await getAnalysisList(postData);
      if ( status !== 200 ) return
      this.total = data.total;
      this.tableData = data.data;
      console.log( data, 'anan list')
    },
  	addBtnClick() {
      this.$router.push('/productanalysishandle')
  	},
  	dialogCancelClick() {
      this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
      if (this.dialogType === 'delete') {
        const { status } = await deleteAnalysis(this.handle_row.id);
        if (status === 200) this.dialogVisible = false
      }
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this.handle_row = {};
      this._getAnalysisList();
  	},
  	handelPagesizeChange(size) {
      this.page_size = size;
      this._getAnalysisList();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this._getAnalysisList();
  	},
    deleteAnalysisClick(row) {
      this.handle_row = row;
      this.dialogTitle = '删除公告';
      this.dialogType = 'delete';
      this.dialogVisible = true;
    },
    editAnalysisClick(row) {
      this.$router.push({
        path: '/productanalysishandle',
        query: {
          uuid: row.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.addBtn {
	float: right;
	margin-bottom: 40px;
}
.table-wrap {
  margin-bottom: 40px;
  .project-img {
    width: 100%;
    max-height: 300px;
  }
}
.operation-wrap {
	display: flex;
	justify-content: space-around;
	color: @color-text;
	.opration-item{
		cursor: pointer;
	}
}
.dialog-body-wrap {
	text-align: center;
}
/deep/.el-table__row {
  height: 200px;
}
</style>
